export default __webpack_public_path__ + "static/media/number-3.47c0db0c.svg";